import React, { useMemo } from 'react'
import T from 'prop-types'
import { styled } from '@mui/system'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Link } from 'react-router-dom'
import { ROLE_SUPER_ADMIN, useAuth } from 'auth'

import {
  USERS_LIST_TYPE_SIXT_USERS,
  USERS_LIST_TYPE_PARTNERS,
  USERS_LIST_TYPE_PARTNER_USERS,
} from './usersLib'

const CustomTab = ({ to, ...props }) => {
  return (
    <Link to={to}>
      <Tab component="p" {...props} />
    </Link>
  )
}

const UsersHeader = ({
  onNew,
  listType,
  enabledListTypes = [USERS_LIST_TYPE_SIXT_USERS],
  contentIsReadOnly = false,
}) => {
  const { t } = useTranslation()

  const { hasOneOfRoles } = useAuth()

  const superAdmin = useMemo(
    () => hasOneOfRoles([ROLE_SUPER_ADMIN]),
    [hasOneOfRoles]
  )

  const tabIndex = useMemo(() => {
    const tabList = {}
    let i = 0

    enabledListTypes.includes(USERS_LIST_TYPE_SIXT_USERS) &&
      (tabList.sixtUsers = i++)
    enabledListTypes.includes(USERS_LIST_TYPE_PARTNER_USERS) &&
      (tabList.partnerUsers = i++)
    enabledListTypes.includes(USERS_LIST_TYPE_PARTNERS) &&
      (tabList.partners = i++)

    return tabList[listType]
  }, [enabledListTypes, listType])

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Tabs value={tabIndex}>
          {enabledListTypes.includes(USERS_LIST_TYPE_SIXT_USERS) && (
            <CustomTab
              to="/users?type=sixtUsers"
              label={t('users.tabsTitles.sixtUsers')}
            />
          )}
          {enabledListTypes.includes(USERS_LIST_TYPE_PARTNER_USERS) && (
            <CustomTab
              to="/users?type=partnerUsers"
              label={t('users.tabsTitles.partnerUsers')}
            />
          )}
          {enabledListTypes.includes(USERS_LIST_TYPE_PARTNERS) && (
            <CustomTab
              to="/users?type=partners"
              label={t('users.tabsTitles.partners')}
            />
          )}
        </Tabs>
      </div>

      {contentIsReadOnly === false && superAdmin && (
        <Button
          color="primary"
          variant="contained"
          onClick={onNew}
          data-testid="button-new"
        >
          {listType === USERS_LIST_TYPE_PARTNERS
            ? t('users.pageHeader.newPartnerButton')
            : t('users.pageHeader.newUserButton')}
        </Button>
      )}
    </Container>
  )
}

UsersHeader.propTypes = {
  listType: T.oneOf([
    USERS_LIST_TYPE_SIXT_USERS,
    USERS_LIST_TYPE_PARTNER_USERS,
    USERS_LIST_TYPE_PARTNERS,
  ]).isRequired,
  enabledListTypes: T.arrayOf(T.string),
  onNew: T.func.isRequired,
}

export default UsersHeader

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))
